

export const authenticationService = {
    login,
    logout,
    validateToken
};


function validateToken(){
   let usr = localStorage.getItem('currentUser');
   let currentUser = JSON.parse(usr);

   let validUser = null;
   if(currentUser != null && currentUser.activeUntil != null) {
       let activeTime = new Date(currentUser.activeUntil)
       let now = new Date();
       console.log("validatedToken:" + activeTime.getTime());
       console.log("now:" + now.getTime());
       if(activeTime > now){
            validUser = currentUser;
       }else{
           console.log("user timed out");
       }
   }else{
       console.log("invalid User");
   }
   return validUser;
}

async function login(username, password) {
    return new Promise(resolve =>
        setTimeout(() => {
            let loggedInUser = null;
            if(username !== null && password === '8675309'){
                let now = new Date();
                let timeout = new Date(now.getTime()+ 60 * 60000);
                loggedInUser = {
                    firstName : 'Chuck',
                    lastName :'Norris',
                    activeUntil :timeout,
                    token : 1234
                }
            }
            localStorage.setItem('currentUser', JSON.stringify(loggedInUser));
            resolve(loggedInUser);
        }, 1000)
    );

    // const requestOptions = {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify({ username, password })
    // };
    //
    //
    // return fetch(`${config.apiUrl}/users/authenticate`, requestOptions)
    //     .then(handleResponse)
    //     .then(user => {
    //         // store user details and jwt token in local storage to keep user logged in between page refreshes
    //         localStorage.setItem('currentUser', JSON.stringify(user));
    //         return user;
    //     });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
}